import React from 'react';
import {ListItem as MuiListItem} from '@mui/material';
import clsx from 'clsx';
import styles from './ListItem.module.scss';
import {PERMISSION, Permission} from '../../../../permissions/types';

export type ListItemCommonProps = {
  selectedLeftIndicator?: boolean;
  selectedIconIndicator?: boolean;
  selectedIndicatorColor?: string;
  permission?: Permission;
  component?: any;
  to?: string;
};

export type ListItemProps = ListItemCommonProps & {
  selected?: boolean;
  disabled?: boolean;
} & React.ComponentProps<typeof MuiListItem>;

const ListItem = React.forwardRef<any, ListItemProps>((props, ref) => {
  if (props.permission === PERMISSION.FORBIDDEN) {
    return null;
  }

  const {
    selectedLeftIndicator,
    selectedIconIndicator,
    selectedIndicatorColor,
    permission,
    component,
    to,
    onClick,
    ...muiProps
  } = props;

  const isDisabled = props.disabled || permission === PERMISSION.DISALLOWED;

  const className = clsx(
    {
      [styles.selectedLeftIndicator]: selectedLeftIndicator,
      [styles.selectedIconIndicator]: selectedIconIndicator,
    },
    props.className,
  );

  const style = {
    ...(props.selected && selectedIndicatorColor ? {borderColor: selectedIndicatorColor} : {}),
    ...(isDisabled ? {pointerEvents: 'none', opacity: 0.6, cursor: 'default'} : {cursor: 'pointer'}),
    ...props.style,
  };

  const handleClick = (event: React.MouseEvent) => {
    if (isDisabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <MuiListItem
      ref={ref}
      disabled={isDisabled}
      selected={props.selected}
      className={className}
      style={style}
      component={component}
      onClick={handleClick}
      {...(to && !isDisabled ? {to} : {})}
      {...muiProps}
    />
  );
});

export default ListItem;

ListItem.displayName = 'ListItem';
